import html2canvas from "html2canvas";

/**
 * 抄表结算-打印与导出的公共工具。
 * 原先在 runxingtai / jingxi / jingxiCommon / haisida 四个模板中逐字重复,现统一到此。
 * 注意:statement_base 使用的是 scale:6 + 后端 xlsx 导出,属另一套设计体系,不走此工具。
 */

/**
 * 将 DOM 元素通过 html2canvas 转图后,置入隐藏 iframe 触发浏览器打印。
 * @param {HTMLElement} el 要打印的容器元素
 * @param {{scale?: number}} [options]
 */
export function printElement(el, { scale = 1 } = {}) {
  if (!el) return;
  html2canvas(el, { scale }).then(data => {
    const styleContent = `
      @media print {
        @page {
          /* 横向 */
          size: A4;
          /* 边距 上右下左 */
          margin: 15cm; /* 设置页边距 */
        }
      }
    `;
    // 创建用于 print 的样式元素
    const styleTag = document.createElement("style");
    styleTag.innerHTML = styleContent;
    styleTag.media = "print1";

    // 创建 iframe,设置要打印的内容
    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.contentDocument.head.append(styleTag); // 设置 iframe 内部样式
    iframe.contentDocument.body.append(data); // 设置 iframe 内部数据
    iframe.contentDocument.close();
    iframe.contentWindow.print(); // 执行打印
    document.body.removeChild(iframe); // 移除 iframe
  });
}

/**
 * 将原生 table(通过 id 定位)的 outerHTML 导出为 .xls 文件(前端导出)。
 * @param {string} id 原生 table 的 id
 * @param {string} [name='抄表详情'] 文件名前缀
 */
export function exportTableToExcel(id, name = "抄表详情") {
  const table = document.getElementById(id);
  if (!table) return;
  const html = table.outerHTML;
  const blob = new Blob([html], { type: "application/vnd.ms-excel" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name + "excel.xls";
  a.click();
  window.URL.revokeObjectURL(url);
}
